module.exports = __webpack_public_path__ + "static/media/Ab1.aa0ddf7c.mp3";